const APP = {
	name		   		: 'Alibra School',
	desktopXsWidth 		: 1199,
	tabletWidth    		: 991,
	tabletXsWidth  		: 767,
	mobileWidth    		: 599,
	websiteWrapper 		: $('#website-wrapper'),
	workArea       		: $('.js-workarea'),
	popupTrigger   		: $('.js-popup-trigger'),
	audioLink   		: $('.js-audio-link'),
	hiddenClass	   		: 'carousel--hidden',
	licenseesGallery 	: $('.js-licensees-gallery'),
	awardsGallery 	 	: $('.js-awards-gallery'),
	certificatesGallery : $('.js-certificates-gallery'),
	freeClassesGallery	: $('.js-free-classes-gallery'),
	defaultGallery		: $('.js-default-gallery'),
	noLoadedClass		: 'website-wrapper--no-load'
};